import { Alert, Box, Container } from '@mui/material';
import { useState } from 'react';

import { isSignedIn, useAuth } from '@/features/scaffolding/components/AuthContext';
import { AppPage, Loading } from '@/shared/components';
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle';

import SessionGrid from './SessionGrid';
import useKillSessionMutation from '../hooks/useKillSessionMutation';
import { useListSessionsQuery } from '../hooks/useListSessionsQuery';
import KillSessionDialog from './KillSessionDialog';
import PageHeader from '@/shared/components/PageHeader';


const ManageSessionsPage = () => {
  const [sessionToKill, setSessionToKill] = useState<string | null>(null);
  const { mutate: kill, error: killSessionError } = useKillSessionMutation();
  const { sessionState } = useAuth();
  const isAuthReady = isSignedIn(sessionState);

  const title = 'Manage CXVH Sessions';
  useDocumentTitle(title);

  const {
    data: sessions,
    isLoading,
    error,
    refetch,
  } = useListSessionsQuery({
    refetchInterval: 5000,
  });

  const showLoading = !isAuthReady || isLoading;

  const handleKillRequest = (sessionId: string) => {
    setSessionToKill(sessionId);
  };



  const handleKillConfirm = async (sessionId: string) => {
    await kill(sessionId);
    setSessionToKill(null);
    refetch();
  };

  const handleKillCancel = () => {
    setSessionToKill(null);
  };

  return (
    <AppPage title={title} requiredPermissions={['menu:admin:sessions']}>
      <Container maxWidth="xl" sx={{ marginTop: 4, marginBottom: 4 }}>
        <PageHeader title={title} subtitle="Place where you can manage your sessions. You can see the status of each session and kill them if needed." />
        <Box sx={{ marginTop: 4 }}>
          {showLoading && <Loading />}
          {error && (
            <Alert variant="outlined" color="error">
              {error.message}
            </Alert>
          )}
          {killSessionError && (
            <Alert variant="outlined" color="error">
              {killSessionError.message}
            </Alert>
          )}
          {sessions && (
            <SessionGrid
              sessions={sessions}
              onKillSession={handleKillRequest}
              onChangeReservedStatus={()=>refetch()}
            ></SessionGrid>
          )}
        </Box>

        <KillSessionDialog
          open={sessionToKill !== null}
          sessionId={sessionToKill}
          onConfirm={handleKillConfirm}
          onCancel={handleKillCancel}
        />
      </Container>
    </AppPage>
  );
};

export default ManageSessionsPage;
